import { render, staticRenderFns } from "./WebStoreOinCard.vue?vue&type=template&id=6d52fe10&"
import script from "./WebStoreOinCard.vue?vue&type=script&lang=js&"
export * from "./WebStoreOinCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports